module.exports = __webpack_public_path__ + "img/ais.5c91abc5.jpg";